import React, {useReducer} from 'react'

import LoginActions from '../../../../actions/LoginActions.js'
import reducer from '../../../../helpers/reducer.js'

import {H3, H5, Button, Alert} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'

interface MijnwebwinkelSettingsState {
    loading: boolean
    verified: boolean
    error: string
}

const initialState: MijnwebwinkelSettingsState = {
    loading: false,
    verified: false,
    error: ''
}

interface MijnwebwinkelSettingsProps {
    user: Customer
    onChange: (user: Customer, save?: boolean) => void
}

export default function MijnwebwinkelSettings({user, onChange}: MijnwebwinkelSettingsProps) {
    const [{loading, verified, error}, dispatch] = useReducer<React.Reducer<MijnwebwinkelSettingsState, Partial<MijnwebwinkelSettingsState>>>(reducer, initialState)

    function onChangeChecked(key, event) {
        user.settings.webshops.mijnwebwinkel[key] = event.target.checked

        onChange(user)
    }

    function onChangeValue(key, event) {
        user.settings.webshops.mijnwebwinkel[key] = event.target.value

        onChange(user)
    }

    function onVerifyConnection() {
        dispatch({loading: true, verified: false, error: ''})

        onChange(user, true)

        setTimeout(() => { // wait for saving
            LoginActions.verifyWebshop('mijnwebwinkel', (err) => {
                if (err) {
                    dispatch({loading: false, error: `Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`})
                } else {
                    dispatch({loading: false, verified: true})
                }
            })
        }, 1000)
    }

    return (
        <div>
            <H3 style={{marginBottom: 36}}>Mijnwebwinkel</H3>

            <H5 style={{marginBottom: 24}}>Instellingen</H5>

            <FormStack>
                <Toggle
                    label='Actief'
                    checked={user.settings.webshops.mijnwebwinkel.active}
                    onChange={(event) => onChangeChecked('active', event)}
                />

                {user.settings.webshops.mijnwebwinkel.active &&
                    <>
                        <Input
                            label='Store token'
                            info='Deze kun je aanmaken in je Mijnwebwinkel omgeving.'
                            value={user.settings.webshops.mijnwebwinkel.storeToken}
                            onChange={(event) => onChangeValue('storeToken', event)}
                        />

                        <Select
                            label='Update bestelling status in Mijnwebwinkel'
                            info=''
                            value={user.settings.webshops.mijnwebwinkel.updateStatus}
                            onChange={(event) => onChangeValue('updateStatus', event)}
                        >
                            <option value=''>Nooit</option>
                            <option value='confirm'>Na bevestigen</option>
                            <option value='afterSent'>Na verzenden</option>
                        </Select>

                        <Toggle
                            label='Consument opmerking meegeven als bezorginstructie'
                            checked={user.settings.webshops.mijnwebwinkel.useComment}
                            onChange={(event) => onChangeChecked('useComment', event)}
                        />

                        <Button
                            variant='text'
                            loading={loading}
                            onClick={onVerifyConnection}
                        >
                            Verifieer
                        </Button>

                        {error && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({error: ''})} variant='error'>{error}</Alert>
                        )}

                        {!error && verified && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({verified: false})}>Verificatie succesvol.</Alert>
                        )}
                    </>

                }
            </FormStack>
        </div>
    )
}
